import React from 'react';
import request from 'arcdynamic-request';
import {GET_ALL_TENANTS} from '../../consts/queries';
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";

class SelectMultiTenantFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            index: false,
        };
    }

    componentDidMount() {
        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.dataquery.execute',
            params: [GET_ALL_TENANTS, {}],
        }).then(res => {
            const index = {};

            if (res.data) res.data.forEach(x => index[x.ARCIMEDES_ROW_ID] = x);

            this.setState({
                items: res.data,
                index,
            });
        });
    }

    render() {
        const { items } = this.state;
        const { theme, value, valueKey, label, disabled, data, isFilter, handleParentChange} = this.props;

        return (
            <Dropdown theme={theme}
                      dropdownType='multiple'
                      optionsType='tenant'
                      optionKey='ARCIMEDES_ROW_ID'
                      optionLabelKey='NAME'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      handleParentChange={handleParentChange}
            />
        );
    }
}

SelectMultiTenantFilter.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
};

export default SelectMultiTenantFilter;
